// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--MBp7c","text":"_93444fe79c--text--vt6ar"};